module.exports = __webpack_public_path__ + "img/platform6.49e1faf4.png";